// extracted by mini-css-extract-plugin
export default {"loading":"filters_tab-module___loading___c331d7a9"};